(() => {
  const timelines = document.querySelectorAll('[data-contact-timeline]');
  if (!timelines.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    timelines.forEach((timeline) => timeline.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.25 });
  timelines.forEach((timeline) => observer.observe(timeline));
})();
